class TopBarComponent extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        const itemsContainer = this.querySelector('.nv-top-bar-items');
        
        if (!itemsContainer) return;

        // Duplicate items for seamless infinite scroll on mobile
        const duplicateItems = () => {
            if (window.innerWidth <= 768) {
                // Get original items
                const items = Array.from(itemsContainer.children);
                
                // Check if items are already duplicated
                if (!itemsContainer.hasAttribute('data-duplicated')) {
                    // Clone and append items for seamless loop
                    items.forEach(item => {
                        const clone = item.cloneNode(true);
                        itemsContainer.appendChild(clone);
                    });
                    itemsContainer.setAttribute('data-duplicated', 'true');
                }
            } else {
                // Remove duplicates on desktop
                if (itemsContainer.hasAttribute('data-duplicated')) {
                    const items = Array.from(itemsContainer.children);
                    const half = items.length / 2;
                    items.slice(half).forEach(item => item.remove());
                    itemsContainer.removeAttribute('data-duplicated');
                }
            }
        };

        // Initialize
        duplicateItems();

        // Handle resize
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                duplicateItems();
            }, 250);
        });

    
        
    }
}
// Define custom element
customElements.define('nv-top-bar-section', TopBarComponent);